export default __webpack_public_path__ + "media/images/phone-ef17b3967483bdd87d290adae02ca647.svg";